import { BasePage as CngBasePage } from 'cng-web-lib'
import React from 'react'
import UploadMasterData from './UploadMasterData'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'

function WrappedUploadPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <UploadMasterData showNotification={showSnackbar} {...props} />
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

export {
  WrappedUploadPage as UploadPage
}
